function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".queued-view__position", shadowSelector, " {height: 415px;}.queued-view-footer__style", shadowSelector, " {width: 100%;height: 60px;background: #f3f2f2;margin-top: 3%;}.overwrite-all__padding", shadowSelector, " {padding-left: 20px;padding-top: 20px;width: 300px;}.deploy-button__padding", shadowSelector, " {top: 13px;right: 10px;}"].join('');
}
export default [stylesheet];